import { fromArrayToString } from '../../utils/from-array-to-string.js';

const normaliseQueryParams = (queryParams)=>Object.entries(queryParams).filter((entry)=>{
        const isValidValue = (value)=>[
                'string',
                'undefined'
            ].includes(typeof value)
        ;
        const [, value1] = entry;
        return isValidValue(value1) || Array.isArray(value1) && value1.every(isValidValue);
    }).reduce((acc, [key, value])=>{
        const result = fromArrayToString(value);
        if (result !== undefined) {
            acc[key] = result;
        }
        return acc;
    }, {})
;

export { normaliseQueryParams };
//# sourceMappingURL=normalise-params.js.map
